import { AbstractControl, FormGroup, FormArray } from '@angular/forms';


export class FormHelpers {
  static printControlState(control: AbstractControl, filter: (c: AbstractControl) => boolean = c => !c.valid) {
    let str = '';
    this.processControlRecursively(control, (c, l, n) => {
      if (filter(c)) {
        str += `${'\t'.repeat(l)}${n || '[root]'}: [v=${c.valid}, t=${c.touched}, d=${c.dirty}]\r\n`;
      }
    });
  }

  static processControlRecursively(
    c: AbstractControl,
    action: (ctrl: AbstractControl, level: number, name: string) => void,
    level: number = 0,
    name: string = ''
  ) {
    action(c, level, name);
    if (c instanceof FormGroup) {
      Object.keys(c.controls).forEach(key => this.processControlRecursively(c.controls[key], action, level + 1, key));
    } else if (c instanceof FormArray) {
      const fa = c as FormArray;
      for (let i = 0; i < fa.controls.length; i++) {
        const element = fa.controls[i];
        this.processControlRecursively(element, action, level + 1, i.toString());
      }
    }
  }
}
